import React from "react";
import SkeletonLoader from "../../index";

const SkeletonData = ({ height = "56px", paddingX = "13px" }) => {
  return (
    <td
      style={{ height: height, paddingLeft: paddingX, paddingRight: paddingX }}
    >
      <SkeletonLoader variant="text" width="100%" />
    </td>
  );
};

export default SkeletonData;
